import { whenSessionBooted } from '../../app/sessionSlice';
import { refreshNow } from '../http/client';
import { tokenStorage } from './tokenStorage';

/** A Platform access token valid for at least 30 s, or null when signed out (cart and assistant calls). */
export async function freshPlatformToken(): Promise<string | null> {
  // Boot may still be restoring or adopting the Platform session; leaving now for a silent check
  // of the cart's own would drop a refresh token that was just rotated.
  await whenSessionBooted();
  const token = tokenStorage.getAccessToken(); if (!token) return null;
  let claims: { exp?: number };
  try { claims = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); } catch { return null; }
  if (claims.exp && claims.exp * 1000 <= Date.now() + 30000) await refreshNow();
  return tokenStorage.getAccessToken();
}
